import { Layout } from "antd";
import MenuWrapper from "./menu";

const FooterWrapper = ({
  handleClickMenu,
  activeMenu,
  menuItems,
  windowWidth,
  loading,
}) => {
  const { Footer } = Layout;

  return (
    <Footer className="block sm:hidden p-0 fixed bottom-0 bg-transparent  w-full z-40 ">
      <MenuWrapper
        className="rounded-t-2xl shadow-footer footer-wrapper  "
        handleClickMenu={handleClickMenu}
        activeMenu={activeMenu}
        mode="horizontal"
        menuItems={menuItems}
        windowWidth={windowWidth}
        loading={loading}
      />
    </Footer>
  );
};
export default FooterWrapper;
